module.exports = __webpack_public_path__ + "assets/img/sharetimeout.616b86fb.png";